module.exports = __webpack_public_path__ + "img/qingdan.e372dabd.png";